<div class="page-layout carded fullwidth inner-scroll">
    <!-- TOP BACKGROUND -->
    <div class="top-bg primary"></div>
    <!-- / TOP BACKGROUND -->
    <!-- CENTER -->
    <div class="center">
        <!-- CONTENT HEADER -->
        <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">
            <h2 class="m-0"></h2>
        </div>
        <!-- / CONTENT HEADER -->
        <!-- CONTENT CARD -->
        <div class="content-card">

            <img src="{{urlBanner}}" alt="Logo-Norm35" class="centradoIMG ">

            <!-- / CONTENT TOOLBAR -->
            <!-- CONTENT -->
            <div class="content-card mainDiv" style="margin-top: 2%; margin-left: 2%; margin-right: 2%;">
                <div>
                    <p style="font-weight: bold;">{{ 'WIZARD.COLABORADORES.TITLE' | translate}} </p>
                    <div>
                        <p>{{ 'WIZARD.COLABORADORES.SUBTITLE' | translate}} </p><br>
                        <table class="blueTable" style="width: 100%;">
                            <tr>
                                <th>{{ 'WIZARD.COLABORADORES.TABLE_LABEL01' | translate}} </th>
                                <td>
                                    <div *ngIf="statusmater" clas="divTd">
                                        <textarea style="border: none; width: 100%; -webkit-box-sizing: border-box; -moz-box-sizing: border-box; box-sizing: border-box;" matInput autosize [minRows]="minRows" (blur)="onBlurPractica($event,idSeccionTmp,'requerimiento');" ng-keydown="onBlurPractica()">{{requerimientoTmp}} </textarea>
                                    </div>
                                    <div *ngIf="!statusmater" class="divTd">
                                        <!--{{requerimientoTmp}}-->
                                        <textarea [disabled]="true" style="border: none; width: 100%; -webkit-box-sizing: border-box; -moz-box-sizing: border-box; box-sizing: border-box;" matInput autosize [minRows]="minRows">{{requerimientoTmp}} </textarea>
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="center center">
                                        <!--<button mat-icon-button aria-label="Example icon-button with a heart icon" (click)="openDialog()" style="width: 150px;">
                                            <mat-icon style="font-size: 24px;">play_circle_outline</mat-icon>
                                            <span style="font-size: 12px; padding-top: 4px;">{{ 'WIZARD.DOCUMENTADOR.LABEL01' | translate}}</span>
                                          </button>-->
                                    </div>
                                </td>
                            </tr>

                        </table><br>

                    </div>
                </div>

                <hr>
            </div>
            <!-- Sección de consultar tareas-->


            <hr>
            <hr>


            <!--<div *ngIf=" dataId.id==d atita.position ">-->
        </div>
        <!-- / CONTENT -->
    </div>
    <!-- / CONTENT CARD -->
</div>
<!-- / CENTER -->